var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"auto"}},[_c('img',{attrs:{"src":_vm.imageUrl,"height":"32"}})]),_vm._v(" "),_c('v-col',[_vm._t("text",null,{"isRisk":_vm.isRisk})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }